import { createSlice } from '@reduxjs/toolkit';

import app from 'app/config/app';
import Response from 'app/config/Response';
import isEmpty from 'helpers/isEmpty';

const initialState = {
  index: {
    data: [],
    params: {
      page_size: app.perPage || 10,
      page_number: 1,
    },
    isLoading: false,
    totalCount: 0,
    totalPage: 0,
    isError: false,
    errorCode: null,
    errorMessage: null,
  },
  show: {
    showBriefDetailModal: false,
    isLoading: false,
    isError: false,
    errorCode: null,
    errorMessage: null,
    data: null,
  },
};

export const partnerApiLogSlice = createSlice({
  name: 'partnerApiLogs',
  initialState,
  reducers: {
    getPartnerApiLogsInit: (state) => {
      state.index = {
        ...state.index,
        isLoading: true,
        isError: false,
        errorCode: null,
        errorMessage: null,
      };
    },

    getPartnerApiLogsSuccess: (state, { payload }) => {
      let { data, pagination } = payload;

      const { totalCount, totalPage, currentPage, pageSize } = pagination;

      let startSN = (currentPage - 1) * pageSize;

      data = data?.map((item) => ({ sn: (startSN += 1), ...item }));

      state.index = {
        ...state.index,
        isLoading: false,
        isError: false,
        errorCode: null,
        errorMessage: null,
        data,
        totalCount,
        totalPage,
      };
    },

    getPartnerApiLogsFailure: (state, { payload }) => {
      state.index = {
        ...state.index,
        isLoading: false,
        isError: true,
        errorCode: payload?.response?.status ?? 0,
        errorMessage: payload?.response?.message,
      };
    },

    resetGetPartnerApiLogsFailure: (state) => {
      state.index = {
        ...state.index,
        isLoading: false,
        isError: false,
        errorCode: null,
        errorMessage: null,
      };
    },

    setParam: (state, { payload }) => {
      state.index.params = { ...state.index.params, ...payload };
    },

    resetParam: (state) => {
      state.index.params = {
        page_size: state.index.params.page_size,
        page_number: 1,
      };
    },

    deleteFilterParams: (state, { payload }) => {
      if (Array.isArray(payload)) payload.forEach((key) => delete state.index.params[key]);
      else delete state.index.params[payload];
    },

    getPartnerApiLogInit: (state) => {
      state.show = {
        ...state.show,
        showBriefDetailModal: true,
        isLoading: true,
        isError: false,
        errorCode: null,
        errorMessage: null,
        data: null,
      };
    },

    openPartnerApiLogDetails: (state, { payload }) => {
      state.show = {
        ...state.show,
        showBriefDetailModal: true,
        isLoading: false,
        isError: false,
        errorCode: null,
        errorMessage: null,
        data: payload,
      };
    },

    getPartnerApiLogSuccess: (state, { payload }) => {
      if (isEmpty(payload?.data)) {
        state.show = {
          ...state.show,
          isLoading: false,
          isError: true,
          errorCode: Response.HTTP_NOT_FOUND,
          errorMessage: 'Partner API log not found',
        };
      } else {
        state.show = {
          ...state.show,
          isLoading: false,
          isError: false,
          errorCode: null,
          errorMessage: null,
          data: payload.data,
        };
      }
    },

    getPartnerApiLogFailure: (state, { payload }) => {
      state.show = {
        ...state.show,
        isLoading: false,
        isError: true,
        errorCode: payload?.response?.status ?? 0,
        errorMessage: payload?.response?.message,
        data: null,
      };
    },

    hidePartnerApiLogDetails: (state) => {
      state.show = {
        showBriefDetailModal: false,
        isLoading: false,
        isError: false,
        errorCode: null,
        errorMessage: null,
        data: null,
      };
    },
  },
});

export const {
  getPartnerApiLogsInit,
  getPartnerApiLogsSuccess,
  getPartnerApiLogsFailure,
  resetGetPartnerApiLogsFailure,
  setParam,
  resetParam,
  deleteFilterParams,
  getPartnerApiLogInit,
  openPartnerApiLogDetails,
  getPartnerApiLogSuccess,
  getPartnerApiLogFailure,
  hidePartnerApiLogDetails,
} = partnerApiLogSlice.actions;

export default partnerApiLogSlice.reducer;
